import React from "react";
import HeaderOne from "../components/HeaderOne";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import "./PolicyPages.css";

const sections = [
  {
    num: "01",
    title: "Order Processing Time",
    text: "All orders are processed within 1–3 business days after successful payment confirmation. Orders placed on Sundays or public holidays will be processed on the next working business day.",
  },
  {
    num: "02",
    title: "Shipping Coverage",
    text: "We currently deliver across Tamil Nadu and selected locations in India. Delivery availability may vary based on courier service coverage.",
  },
  {
    num: "03",
    title: "Estimated Delivery Time",
    list: [
      "Within Tamil Nadu: 2–5 business days",
      "Other States: 4–8 business days",
    ],
    note: "Delivery timelines may vary due to weather conditions, festivals, strikes, or courier delays.",
  },
  {
    num: "04",
    title: "Shipping Charges",
    text: "Shipping charges are calculated at checkout based on product weight, delivery location, and courier partner rates. Free shipping may be offered on selected products or promotional orders.",
  },
  {
    num: "05",
    title: "Order Tracking",
    text: "Once your order is shipped, tracking details will be shared via SMS, email, or WhatsApp. Customers can track their orders in real time using the provided tracking link.",
  },
  {
    num: "06",
    title: "Delivery Attempts",
    text: "Courier partners will attempt delivery 2–3 times. If delivery fails due to incorrect address or customer unavailability, the order may be returned to origin.",
  },
  {
    num: "07",
    title: "Undelivered Orders",
    text: "If an order is returned due to customer error, re-shipping charges will apply. Refunds (if applicable) will be processed after deduction of shipping costs.",
  },
];

const ShippingPolicy = () => {
  return (
    <>
      <HeaderOne />

      <section className="policy-hero">
        <div className="policy-hero-inner">
          <p className="policy-hero-eyebrow">Kalpana Mart</p>
          <h1>Shipping Policy</h1>
          <p className="policy-hero-sub">
            Everything you need to know about how we get your order safely to your door.
          </p>
        </div>
      </section>

      <div className="policy-body">
        <div className="policy-content">
          <div className="policy-meta">
            <span className="policy-badge">
              <span className="policy-badge-dot" />
              Effective immediately
            </span>
          </div>

          <p className="policy-intro">
            We are committed to delivering your orders safely, securely, and within the promised
            time frame. This policy explains our order processing, delivery timelines, and
            related services.
          </p>

          {sections.map((s) => (
            <div className="policy-section" key={s.num}>
              <div className="policy-section-header">
                <span className="policy-section-num">{s.num}</span>
                <h2>{s.title}</h2>
              </div>
              {s.text && <p>{s.text}</p>}
              {s.list && (
                <ul className="policy-list">
                  {s.list.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              )}
              {s.note && (
                <div className="policy-highlight" style={{ marginTop: s.list ? 14 : 0 }}>
                  <p>{s.note}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <FooterOne />
      <BottomFooter />
    </>
  );
};

export default ShippingPolicy;